"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHtmlFromIframe = void 0;
var EmbedWidgets_1 = require("./EmbedWidgets");
var createHtmlFromIframe = function (token, _a) {
    var isPrintMode = _a.isPrintMode;
    if (!token.embedUrl) {
        return "";
    }
    if (isPrintMode) {
        return printIframePlaceholder(token.width);
    }
    return "\n    <div class=\"iframe-widget\">\n      ".concat((0, EmbedWidgets_1.createHtmlFromEmbedWidgets)(token), "\n    </div>\n  ");
};
exports.createHtmlFromIframe = createHtmlFromIframe;
var printIframePlaceholder = function (resizePercent) {
    var wrapperWidth = 100;
    var wrapperPaddingBottom = 55;
    var fontSizePx = 15;
    var iconWidthPx = 50;
    var marginBottomPx = 15;
    if (resizePercent && typeof resizePercent === "number") {
        fontSizePx *= resizePercent / 100;
        iconWidthPx *= resizePercent / 100;
        marginBottomPx *= resizePercent / 100;
        wrapperWidth *= resizePercent / 100;
        wrapperPaddingBottom *= resizePercent / 100;
    }
    var wrapperStyle = "width: ".concat(wrapperWidth, "%; height: 0; padding-bottom: ").concat(wrapperPaddingBottom, "%;");
    return "\n    <div class=\"embedded-content\">\n      <div class=\"print-placeholder avoid-page-break\" style=\"".concat(wrapperStyle, "\">\n        <div class=\"print-background\">\n          <img class=\"cloud\" src=\"/Public/Assets/Images/cloud-bg.svg\"/>\n        </div>\n        <div class=\"print-message\">\n          <img\n            class=\"offline-icon\"\n            src=\"/Public/Assets/icons/offline-grey.svg\"\n            style=\"width: ").concat(iconWidthPx, "px; margin-bottom: ").concat(marginBottomPx, "px;\"\n          />\n          <div class=\"description\" style=\"font-size: ").concat(fontSizePx, "px;\">Iframe content can't be viewed offline</div>\n        </div>\n      </div>\n    </div>\n  ");
};
